import { OrderStatus } from '../proxy/enums/order-status.enum';

/**
 * winepassport#389 — regla única de "¿el admin puede confirmar el pago de esta orden?",
 * compartida entre el listado y el detalle de órdenes (antes vivía solo en el detalle).
 * Transferencia o tarjeta (Mercado Pago pendiente) en estado Pendiente ("Validando pago").
 */
export function canConfirmPayment(order: { paymentMethod?: string; orderStatus?: OrderStatus } | null | undefined): boolean {
  if (!order) return false;
  const paymentMethod = order.paymentMethod?.toLowerCase();
  return (paymentMethod === 'bank' || paymentMethod === 'credit_card' || paymentMethod === 'card') &&
    order.orderStatus === OrderStatus.Pending;
}
